import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button} from "antd";
import logo from "../../../assets/landingFeatures/explorer.png";
import "./nujobsViewJobsContainer.scss";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";
import NuJobsViewJobDetails from "../nujobsViewJobDetails";
import FooterNuJobs from "../../../landing/footerNuJobs";
import NuJobsViewEventDetails from "../nujobsViewEventDetails";

export default function NuJobsViewJobsContainerOpenSearch({ setCurrentView }) {
    const navigate = useNavigate();
    const { source, jdid, qhoid } = useParams();   
    const {nujobsApplyNow,ViewedJobs, AppliedJobs,FavJobs,skilledBasedJobs,AppliedResponseMetadata} = useNuJobDetailsStore();
    const {openJds,selectedEventJD,selectedEvent} = useNuJobsStore();
    const [jdValues, setJdValues] = useState({});     
   
    
    function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
    } 

    const [containerView, setContainerView] = useState(
          source === "viewevent" ? "event" : "jd"
      );    
    const getJobs = () => {
        switch (source) {
            case "viewevent":
            return selectedEventJD;
            case "opensearch":
            return openJds;            
            case "search":
            return openJds;
            case "viewed":
            return ViewedJobs;
            case "applied":
            return AppliedJobs;
            case "fav":
            return FavJobs;
            case "skills":
            return skilledBasedJobs;
            default:
            return [];
        }
    };

    const isLoggedin = source == "opensearch"?false:true
    const jobs = getJobs()
    const jd = jobs?.find((j) => j?.QhCompanyJID == jdid);
    const selectedJD = jd;  
    const jdWithLogoIndex = jobs?.findIndex((j) => j?.QhCompanyJID == jdid);
    const getCompanyLogoSrc = (rawLogo) => {
        if (!rawLogo) return null;
        if (rawLogo.startsWith("data:image")) return rawLogo;
        return `data:image/png;base64,${rawLogo}`;
    };
  console.log("jd...", jd,jdid, source)
  const companyLogoSrc =
    getCompanyLogoSrc(
      openJds[jdWithLogoIndex]?.companylogo ||
        openJds[jdWithLogoIndex]?.CompanyLogo ||
        openJds[jdWithLogoIndex]?.JDClient?.CompanyLogo,
    ) || null;
    
  const isApplied = ()=>{
        const appIdx = AppliedResponseMetadata?.findIndex((j) => j?.qhcompanyjid == jd?.QhCompanyJID );
        if(AppliedResponseMetadata?.[appIdx]?.isApplied=== true){
           return "Applied"
        }else{
           return "Not Applied"
        }
        return "Not Applied"
    }
    const appliedOn = jd?.nujobsinfo?.appliedon
    const initJDParams = () =>{
        var jdValuesTmp
        if (source !== undefined) {
            jdValuesTmp = {
                job_category: selectedJD?.JDDetails.JobCategory,
                title: selectedJD?.JDDetails.Title,
                client_job_type: selectedJD?.JDClient.ClientJobType,
                job_type: selectedJD?.JDDetails.JobType,
                job_time: selectedJD?.JDDetails.JobTime,
                designation: selectedJD?.JDDetails.Designation,
                roles_and_responsibility: selectedJD?.JDRequired.RoleDetails,
                roletype: selectedJD?.JDRequired.RoleType,
                role: selectedJD?.JDRequired.Role,
                skills: selectedJD?.JDRequired.Skills,
                keywords: selectedJD?.JDRequired.Keywords,
                education: selectedJD?.JDRequired.Education,
                min_ctc: selectedJD?.JDProject.MinCtc,
                max_ctc: selectedJD?.JDProject.MaxCtc,
                postingdate: selectedJD?.JDOther.PostingDate,
                work_location: selectedJD?.JDRequired.WorkLocation,
                work_mode: selectedJD?.JDRequired.WorkMode,
                diversity_only: selectedJD?.JDRequired.Diversity,
                freshers_only: selectedJD?.JDRequired.Fresher,
                interns_only: selectedJD?.JDRequired.Intern,                                                                          
                notice_period: selectedJD?.JDRequired.NoticePeriod,
                min_exp: selectedJD?.JDRequired.MinExperience,
                max_exp: selectedJD?.JDRequired.MaxExperience,
                updatedon: formatUnixDate(selectedJD?.timestamp),
                postedby: selectedJD?.CompanyName,             
            };
            setJdValues(jdValuesTmp);
        }
    }
    //selected jd from table
    useEffect(() => {       
        initJDParams();   
    }, []);


    function getTimeNow(){
        const today = new Date();
        const month = today.getMonth()+1;
        const year = today.getFullYear();
        const date = today. getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate
    }
 
    const encodeJson = () =>{
        let encodedJsonValues ={};
       
        //now override keyword and location
        encodedJsonValues.qhoid= jd?.nujobsinfo?.qhoid;
        encodedJsonValues.qhcompanyjid=jd?.nujobsinfo?.qhcompanyjid;
        encodedJsonValues.companyname=selectedJD.companyname;                           
        return encodedJsonValues
    }
    const handleSignin = () => {
        navigate("/nujobsotpprocess", {
        state: {
            reason: "start",
            trigger: "signin",
        },
        }); 
    };
  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };
  const handleContainerViewJD = () => {
       setContainerView("jd")
  };
  const handleContainerViewEvent = () => {
       setContainerView("event")
  };  
    return (        
    <div className="jobListing-jobview-wrapper">
       <div className="jobListing-header-results"> 
          <div className="header-logo">
              <img className="header-logo-img"src={logo} />
          </div>
          <div className="header-menu">
            <ul className="header-menu">
              <li >
                <a href="/home">QUALLYHIRE AI</a>
              </li>              
              <li >
                <a href="/nujobs">NuJobs</a>
              </li>
              <li>
                <a href="/qhrflowcontact">Support</a>
              </li>                                                                        
            </ul>
          </div>
          <div className="header-sign">
            <Button className="sign-button" onClick={() => handleSignin()}>
              Candidate Sign In
            </Button>
            <Button className="job-button" onClick={() => handlePostJobs()}>
              Post Jobs
            </Button>                                     
          </div>          
       </div>

      <div className="nujobs-details-navigation">
      <div className="nujobs-details-navigation">
          <div className="nujobs-details-navigation-inner">

              {/* Left - Back Button */}
              <button
                  className="nujobs-details-back-btn"
                  onClick={() => navigate(-1)}
              >
                  ← Back
              </button>

              {/* Right - Navigation Tabs */}
              <div className="nujobs-details-tabs">
                  <button
                      className={`nujobs-details-nav-btn ${
                          containerView === "event" ? "active" : ""
                      }`}
                      onClick={handleContainerViewEvent}
                  >
                      Event
                  </button>

                  <button
                      className={`nujobs-details-nav-btn ${
                          containerView === "jd" ? "active" : ""
                      }`}
                      onClick={handleContainerViewJD}
                  >
                      Event JD
                  </button>
              </div>

          </div>
      </div>
      </div>
      {
        containerView == "jd"?
        <>
          <NuJobsViewJobDetails
            jobId={jd?.QhCompanyJID}
            jdValues={jdValues}
            encodeJsonCB={encodeJson}
            isApplied={isApplied}
            appliedOn={appliedOn}
            companyLogo={companyLogoSrc}
          />        
        </>
        :<> 
        	<NuJobsViewEventDetails
            jobId={jd?.QhCompanyJID}
            selectedEvent={selectedEvent}
            selectedEventJD={selectedEventJD}
            encodeJsonCB={encodeJson}
            isApplied={isApplied}
            appliedOn={appliedOn}
            companyLogo={companyLogoSrc}
          />
        </>
      }


       <div className="landing-footer">
          <FooterNuJobs/>
       </div>         
    </div>        

    );
}
